import React from 'react'
import PropTypes from 'prop-types'

import ContentLoader, { Rect } from 'react-content-loader/native'

const TextLoading = ({ width, height, background, foreground }) => {
  return (
    <ContentLoader
      width={width}
      height={height}
      backgroundColor={background}
      foregroundColor={foreground}
      viewBox={`0 0 ${width} ${height}`}
    >
      <Rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
    </ContentLoader>
  )
}

TextLoading.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  background: PropTypes.string,
  foreground: PropTypes.string
}

TextLoading.defaultProps = {
  width: 50,
  height: 16,
  background: '#e4e4e4',
  foreground: '#d4d4d4'
}

export default TextLoading
